/* tslint:disable */
/* eslint-disable */
// this is an auto generated file. This will be overwritten

import * as APITypes from "../API";
type GeneratedMutation<InputType, OutputType> = string & {
  __generatedMutationInput: InputType;
  __generatedMutationOutput: OutputType;
};

export const changeSlide = /* GraphQL */ `mutation ChangeSlide(
  $id: String!
  $url: String!
  $sequence: Float!
  $type: String!
  $pollId: String!
  $pollResults: [PollResultInput]
  $collateralTypeId: String
  $currentOffset: String
) {
  changeSlide(
    id: $id
    url: $url
    sequence: $sequence
    type: $type
    pollId: $pollId
    pollResults: $pollResults
    collateralTypeId: $collateralTypeId
    currentOffset: $currentOffset
  ) {
    id
    url
    sequence
    type
    pollId
    pollResults {
      option
      percentage
      voteCount
      __typename
    }
    collateralTypeId
    currentOffset
    __typename
  }
}
` as GeneratedMutation<
  APITypes.ChangeSlideMutationVariables,
  APITypes.ChangeSlideMutation
>;
export const updateMeetingStatus = /* GraphQL */ `mutation UpdateMeetingStatus($eventid: String!, $meetingstatusflag: Boolean!) {
  updateMeetingStatus(
    eventid: $eventid
    meetingstatusflag: $meetingstatusflag
  ) {
    eventid
    meetingstatusflag
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateMeetingStatusMutationVariables,
  APITypes.UpdateMeetingStatusMutation
>;
export const toggleSlideControl = /* GraphQL */ `mutation ToggleSlideControl(
  $eventid: String!
  $enableSlideControl: Boolean!
  $email: String
) {
  toggleSlideControl(
    eventid: $eventid
    enableSlideControl: $enableSlideControl
    email: $email
  ) {
    eventid
    enableSlideControl
    email
    __typename
  }
}
` as GeneratedMutation<
  APITypes.ToggleSlideControlMutationVariables,
  APITypes.ToggleSlideControlMutation
>;
export const dragSlideForSequence = /* GraphQL */ `mutation DragSlideForSequence($eventid: String!, $isDragging: Boolean!) {
  dragSlideForSequence(eventid: $eventid, isDragging: $isDragging) {
    eventid
    isDragging
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DragSlideForSequenceMutationVariables,
  APITypes.DragSlideForSequenceMutation
>;
